export default function isUserTyping() {
  return ['INPUT', 'TEXTAREA'].includes(document.activeElement?.tagName);
}
